import {
  RawSelectOption,
  SelectableFieldProps,
  SelectOption,
} from '../core-field/selectable-field-props'

export type RadioButtonStyle = 'default' | 'pill'
export type RadioOptionLayout = 'horizontal' | 'vertical'
export type PillVariant = 'segmented' | 'standalone'

/**
 * Semantic color family for a standalone pill's selected highlight. The
 * component owns the actual shade used for each family name.
 */
export type RadioOptionColorFamily =
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'teal'
  | 'blue'
  | 'purple'
  | 'grey'

/**
 * Radio-button options carry a couple of per-option display extras on top of
 * the canonical `{ label, value }` shape. These extras are honored only in the
 * standalone pill style.
 */
export interface RadioOption extends SelectOption {
  /** Per-option icon — standalone pill style only. */
  icon?: string
  /**
   * Semantic color family applied to the option's selected highlight —
   * standalone pill style only. The component owns the actual shade for each
   * family; do not pass raw CSS color strings.
   */
  selectedColorFamily?: RadioOptionColorFamily
}

export type RawRadioOption = RawSelectOption | RadioOption

export const UI2_RADIO_BUTTON_FIELD_DEFAULT_PROPS: Partial<UI2RadioButtonFieldProps> = {
  buttonStyle: 'default',
  isMultiSelect: false,
}

export interface UI2RadioButtonFieldProps extends SelectableFieldProps {
  buttonStyle?: RadioButtonStyle
  pillVariant?: PillVariant
  optionLayout?: RadioOptionLayout
  options?: RawRadioOption[]
}
